import actionTypes from '../constant/constants';

const INITIAL_STATE = {
    currentLocation: {country: 'UK(default)', province: ''}
}
export default (states = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.CURRENT_LOCATION :
            return ({
                ...states,
                currentLocation: action.payload
            })
        default:
            return states;
    }

}



// WEBPACK FOOTER //
// ./src/store/reducers/location-reducer.js